function LoadingScreen() {
  return (
    <div className="w-full h-1 bg-green-100">
      <div className="h-full bg-green-100 animate-loading-bar"></div>
    </div>
  );
}

export default LoadingScreen;
